import LoadingRing from './LoadingRing'

export default LoadingRing
